//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { NsProductCard } from "@nuskin/product-components";

export default {
  name: "NsTopnavProductHighlight",
  components: { NsProductCard },
  props: {
    /**
     * Skus (max: 3)
     * [{sku}]
     */
    skus: {
      type: String,
      default: JSON.stringify([])
    }
  },
  data: function() {
    return {
      localSkus: []
    };
  },
  mounted: function() {
    this.localSkus = JSON.parse(this.skus).filter(sku => !!sku);
  },
  methods: {}
};
